import {Inject, Injectable} from '@angular/core';
import {FileRecordError, FileRecordObject, SessionSizeObject} from './file-record';
import {HttpClient} from "@angular/common/http";
import 'rxjs/add/operator/toPromise';

@Injectable()
export class FileRecordService {
  constructor(@Inject(HttpClient) private readonly http: HttpClient) {
  }

  getSessionContentSize(): Promise<any> {
    let url = `/upload/file/sessionSize`;
    return this.http.get(url, {})
      .toPromise()
      .then(resp => resp)
      .catch(this.handleError);
  }

  getSessionTableContent(): Promise<FileRecordObject[]> {
    let url = `/upload/file/sessionTable`;
    return this.http.get(url, {})
      .toPromise()
      .then(resp => resp)
      .catch(this.handleError);
  }

  getHistoryTableContent(): Promise<FileRecordObject[]> {
    let url = `/upload/file/historyTable`;
    return this.http.get(url, {})
      .toPromise()
      .then(resp => resp)
      .catch(this.handleError);
  }

  getHistoryTableErrorContent(id: string): Promise<FileRecordError[]> {
    const url = `/upload/file/recordErrors/${id}`;
    return this.http.get(url, {})
      .toPromise()
      .then(resp => resp)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  toFileRecordObjectList(jsonFileRecordList: any): FileRecordObject[] {
    let fileRecordObjectList:FileRecordObject[] = new Array<FileRecordObject>();
    for (let jsonFileRecord of jsonFileRecordList) {
      fileRecordObjectList.push(jsonFileRecord);
    }
    return fileRecordObjectList;
  }

  toSessionSizeObject(jsonSessionSize:any): SessionSizeObject{
    let sessionSizeObject = <SessionSizeObject>({
      totalSessionFileCount: jsonSessionSize.totalSessionFileCount,
      totalSessionUploadSize: jsonSessionSize.totalSessionUploadSize,
    });
    console.log('Parsed Session Size:', sessionSizeObject);
    return sessionSizeObject;
  }
}
